export default [
  {
    path: 'kategori-item',
    redirect: { name: 'itemcategories' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'itemcategories',
        component: () => import('@pages/itemcategories/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Kategori Item',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Kategori Item',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'itemcategories-add',
        component: () => import('@pages/itemcategories/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Kategori Item',
          navActiveLink:'itemcategories',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Kategori Item',
              to: { name: 'itemcategories' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'itemcategories-edit',
        component: () => import('@pages/itemcategories/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Kategori Item',
          navActiveLink:'itemcategories',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Kategori Item',
              to: { name: 'itemcategories' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]